module.exports = __webpack_public_path__ + "img/otm-logo-footer.61706027.svg";